export default __webpack_public_path__ + "static/media/04AW1SEP66.92201893.jpg";